<template>
  <div
    id="wspo"
    :class="{
      'wspo-theme-office': context === 'office' || context === 'td',
      'wspo-theme-pm': context === 'pm' || context === 'main-pm'
    }"
  >
    <Lead />
  </div>
</template>

<script>
import Lead from '@/views/Lead.vue';
import { mapGetters, mapActions } from 'vuex';
export default {
  components: {
    Lead
  },
  mounted() {
    this.initialize().then(() => {
      // this.$store.commit('setTour', this.$store.state.tours[0].id);
      // this.$store.commit('updateFeedback', {
      //   username: 'Семен',
      //   email: 'test@test.sd',
      //   phone: '123123132131',
      //   adding: 'Привет, хочу в тур'
      // });
      // this.$store.dispatch('sendFeedback');
    });
  },
  computed: {
    ...mapGetters(['context'])
  },
  methods: {
    ...mapActions(['initialize'])
  }
};
</script>

<style>
#wspo {
  --color-paper: #fff;
  --color-main: #06b;
  --color-second: #ef4123;
  --color-second-alt: #fff200;
  --color-third: #ef9923;
  --color-third-5: #ef992350;
  --color-alt: #0af;
  --color-alt-5: #00aaff50;
  --color-bg: #e3f6ff;
  --color-bg-dark: #cfefff;
  --color-text: #035;
  --color-text-cold: #0a3;
  --color-bg-warm: #f1abd2;
  --color-bg-cold: #43da70;
  --color-bg-cold-5: #43da7050;
  --color-text-5: #035c;
  --color-button: linear-gradient(var(--color-alt) -50%, var(--color-main));
  --color-button-hover: linear-gradient(
    to top,
    var(--color-second) -20%,
    var(--color-second-alt) 150%
  );
  font-family: 'Open Sans', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 14px;
  color: var(--color-text);
}
#wspo.wspo-theme-office {
  --color-bg: #efefef;
  --color-bg-dark: #ccc;
  --color-alt-5: #6666;
  --color-text: #222;
  --color-text-5: #222a;
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
}
#wspo.wspo-theme-pm {
  --color-text: #222;
  --color-text-5: #222a;
  --color-button: #e4042a;
  --color-button-hover: #444;
  --color-main: #e4042a;
  --color-alt: #f7ce00;
  --color-alt-5: #f7ce00aa;
  --color-second-alt: #ff8b9e;
  --color-bg: #fff7ce;
  --color-bg-dark: #fff3b5;
}
#wspo * {
  box-sizing: border-box;
}
.wspo-icon:before,
.wspo-icon-after:after,
.wspo-icon-left:before {
  content: '\f072';
  width: 14px;
  font: 900 normal normal 14px/1 'Font Awesome 5 Pro';
  font-size: 14px;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  color: var(--color-alt-5);
  transition: 0.3s ease-out;
}

/* buttons */
.wspo-button-main,
.wspo-button-second,
.wspo-button-third {
  width: 100%;
  background: var(--color-button);
  outline: none;
  padding: 7px 14px;
  border-bottom: 2px solid var(--color-alt);
  font-family: 'Open Sans';
  font-size: 14px;
  font-weight: 600;
  color: var(--color-paper);
  cursor: pointer;
  border-radius: 4px;
  margin-top: 8px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.wspo-button-second {
  background: var(--color-bg-dark);
  border-bottom-color: var(--color-alt-5);
  color: var(--color-main);
}
.wspo-button-third {
  background: var(--color-paper);
  color: var(--color-main);
  padding: 6px 13px;
  border: 1px solid var(--color-alt-5);
  border-bottom: 2px solid var(--color-alt-5);
  width: unset;
  display: inline-flex;
}
.wspo-button-main:hover {
  background: var(--color-button-hover);
  border-bottom: 2px solid var(--color-second-alt);
}
.wspo-button-second:hover {
  background: var(--color-bg);
  border-bottom-color: var(--color-bg-dark);
  color: var(--color-alt);
}
.wspo-button-third:hover {
  background: var(--color-bg);
}

/* layout */
.wspo-layout {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: var(--color-bg);
  padding: 8px;
}
.wspo-layout-row {
  width: 100%;
  max-width: 1200px;
  /* margin: -12px; */
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  justify-content: center;
}
.wspo-layout-row-short {
  max-width: 1000px;
}

/* forms */
.wspo-form-control {
  position: relative;
  width: 100%;
  max-width: 400px;
  padding: 8px;
  /* cursor: pointer; */
  flex: 2 1 160px;
  user-select: none;
}
.wspo-form-label {
  padding: 4px 12px;
  position: absolute;
  font-size: 11px;
  color: var(--color-text-5);
  font-weight: 600;
  pointer-events: none;
}
.wspo-form-input,
.wspo-form-output {
  width: 100%;
  background-color: var(--color-paper);
  outline: none;
  line-height: 16px;
  padding: 20px 12px 8px;
  border: 1px solid var(--color-alt-5);
  font-family: 'Open Sans';
  font-weight: 700;
  font-size: 16px;
  min-height: 52px;
  cursor: pointer;
  appearance: none;
}
.wspo-form-input:not([readonly]) {
  cursor: text;
}
.wspo-form-output {
  padding-top: 23px;
  white-space: nowrap;
}
.wspo-form-input.is-set,
.wspo-form-output.is-set {
  background-color: var(--color-bg);
  transition: background-color 0.3s;
}
.wspo-form-input.is-set:hover,
.wspo-form-output.is-set:hover {
  background-color: var(--color-paper);
  transition: background-color 0.3s;
}
.wspo-form-multiselect {
  padding: 8px 12px;
  background-color: var(--color-paper);
  border: 1px solid var(--color-alt-5);
  border-top: 0;
}
input:focus {
  outline: 0;
  box-shadow: 0 0 1px var(--color-alt), 0 0 8px var(--color-bg-dark),
    1px 0 12px var(--color-bg);
}
.wspo-form-submit {
  width: 100%;
  background: var(--color-button);
  outline: none;
  padding: 14px 20px;
  border-bottom: 2px solid var(--color-alt);
  font-family: 'Open Sans';
  font-size: 16px;
  font-weight: 600;
  color: var(--color-paper);
  cursor: pointer;
  text-align: center;
  border-radius: 4px;
}
.wspo-form-submit:hover {
  background: var(--color-button-hover);
  border-bottom: 2px solid var(--color-second-alt);
}
.wspo-form-submit.is-disabled,
.wspo-form-submit.is-disabled:hover {
  background: var(--color-button-hover);
  border-bottom: 2px solid var(--color-second-alt);
  opacity: 0.5;
  cursor: wait;
}
.wspo-form-checkbox {
  cursor: pointer;
  display: flex;
  padding: 2px 0;
  transition: 0.1s;
}
.wspo-form-checkbox:before {
  content: '\f0c8';
  font-weight: 300;
  font-size: 18px;
  color: var(--color-alt-5);
  margin-right: 8px;
  transition: 0.1s;
}
.wspo-form-checkbox.wspo-checked {
  font-weight: 700;
  color: var(--color-main);
  transition: 0.1s;
}
.wspo-form-checkbox.wspo-checked:before {
  content: '\f14a';
  font-weight: 700;
  color: var(--color-alt);
  transition: 0.1s;
}
.wspo-form-control-hotel .wspo-form-checkbox {
  text-transform: capitalize;
}

/* tools */

.wspo-price {
  font-size: 22px;
  font-weight: 700;
}
.wspo-small {
  font-size: 12px;
}
.wspo-price .wspo-small {
  font-size: 15px;
  font-weight: 600;
}
.wspo-stick-to-right {
  right: 0;
  left: unset;
}

/* animation */
@keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(359deg);
    transform: rotate(359deg);
  }
}
.blur-enter-active,
.blur-leave-active {
  filter: blur(5px);
}
.blur-enter,
.blur-leave-to {
  filter: blur(0px);
}
</style>
